(function () {
  const MARKER = 'pjs-chat-bottom'
  const BUBBLE_BOTTOM = '32px' /* the same side margin the rest of the site uses */

  /*
     The bubble does not always hang from the same place: closed it sits at the chat's
     root, and opening it moves it into a nested one. They are walked breadth-first
     until it turns up.
  */
  function bubbleRoot () {
    const chat = document.querySelector('shopify-chat')
    if (!chat || !chat.shadowRoot) return null
    const queue = [chat.shadowRoot]
    let visited = 0
    while (queue.length && visited < 60) {
      const root = queue.shift()
      visited++
      if (root.querySelector('.activator-nudge')) return root
      const children = root.querySelectorAll('*')
      for (let i = 0; i < children.length; i++) {
        if (children[i].shadowRoot) queue.push(children[i].shadowRoot)
      }
    }
    return null
  }

  function place () {
    const root = bubbleRoot()
    if (!root) return false
    if (root.querySelector('#' + MARKER)) return true
    const sheet = document.createElement('style')
    sheet.id = MARKER
    /* No transition, so the adjustment does not read as movement. */
    sheet.textContent =
      '.activator-nudge { bottom: ' + BUBBLE_BOTTOM + ' !important; transition: none !important; }'
    root.appendChild(sheet)
    return true
  }

  let waiting = false
  function request () {
    if (waiting) return
    waiting = true
    setTimeout(function () {
      waiting = false
      place()
    }, 120)
  }

  /*
     Waiting for the next check painted the bubble high and dropped it an instant later:
     a jump on every page change. It hooks in as soon as the chat enters the document,
     so its first paint is already in place.
  */
  if (!place()) {
    const docWatcher = new MutationObserver(function () {
      if (place()) {
        docWatcher.disconnect()
        watchChat()
      }
    })
    docWatcher.observe(document.documentElement, { childList: true, subtree: true })
    setTimeout(function () {
      docWatcher.disconnect()
    }, 15000)
  } else {
    watchChat()
  }

  /*
     Opening and closing the chat rebuilds its contents and moves the bubble's root, so
     its own subtree is watched and the position reapplied. It is small and scoped to
     the chat.
  */
  function watchChat () {
    const chat = document.querySelector('shopify-chat')
    if (!chat || !chat.shadowRoot) return
    new MutationObserver(request).observe(chat.shadowRoot, { childList: true, subtree: true })
  }

  /*
     Google's badge is placed by merchantwidget.js in a fixed container (#google-
     merchantwidget-iframe-wrapper) with an inline bottom and !important, so a
     stylesheet cannot beat it: it has to be written into its own style. Google only
     changes its width and height when showing it or opening the card, but if it ever
     rewrites bottom this puts it back. The iframe is anchored to the bottom inside the
     container, so an open card grows upward and does not cover the bubble either. 32px
     from the bubble, 50px of its own height and 14px of air.
  */
  const BADGE_BOTTOM = '96px'
  function raiseBadge (box) {
    if (box.style.getPropertyValue('bottom') !== BADGE_BOTTOM) {
      box.style.setProperty('bottom', BADGE_BOTTOM, 'important')
    }
  }
  function watchBadge () {
    const box = document.getElementById('google-merchantwidget-iframe-wrapper')
    if (!box) return false
    raiseBadge(box)
    new MutationObserver(function () {
      raiseBadge(box)
    }).observe(box, { attributes: true, attributeFilter: ['style'] })
    return true
  }
  if (!watchBadge()) {
    const badgeWatcher = new MutationObserver(function () {
      if (watchBadge()) badgeWatcher.disconnect()
    })
    badgeWatcher.observe(document.documentElement, { childList: true, subtree: true })
    setTimeout(function () {
      badgeWatcher.disconnect()
    }, 60000)
  }

  /* A safety net in case the chat is slow to mount the bubble. */
  let ticks = 0
  const ticker = setInterval(function () {
    place()
    if (++ticks > 60) clearInterval(ticker)
  }, 1000)
})()
